// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

//export const ISSUER = 'https://dev-2hddzh1jknjriv6g.us.auth0.com/';
export const ISSUER = 'https://auth.dsbunny.uk/1ff2dd0e-4c6c-4a8e-add3-d2f799e7d364/v2.0/';
export const CLIENT_ID = "2QwpwWCYEv6jNSYw0S3adssCidrMKPI6";  // Kuromi in auth0.com
